var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMediaMiscDisc = function SvgIconMediaMiscDisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.126 4.984A9.97 9.97 0 0 1 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2a9.97 9.97 0 0 1 7.016 2.874 1 1 0 0 1 .11.11M4 12a8 8 0 0 1 12.906-6.32l-2.874 2.874A4 4 0 1 0 15.874 13h4.064A8.001 8.001 0 0 1 4 12m9.366-1.46a1 1 0 0 0 .095.094 2 2 0 1 1-.094-.094m2.08-.572 2.874-2.873A7.96 7.96 0 0 1 19.938 11h-4.064a4 4 0 0 0-.428-1.032",
    clipRule: "evenodd"
  })));
};
export default SvgIconMediaMiscDisc;